import React from 'react';
import PropTypes from 'prop-types';
import Footer from 'common/Footer';
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';

function KioskFooter(props) {
  return (
    <Footer
      primaryButton={<StyledButton asLink onClick={props.startOver}>Start Over</StyledButton>}
      secondaryButton={<StyledButton asLink onClick={props.goBack}><span><Icon icon='arrow_back' aria-hidden='true'/>Back</span></StyledButton>}
    />
  );
}

KioskFooter.propTypes = {
  startOver: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired
};

export default KioskFooter;
